<template>
  <div class="list-skeleton">
    <v-skeleton-loader
      v-for="index in itemListNumber"
      :key="index"
      type="text"
    />
  </div>
</template>

<script>
export default {
  name: 'ListSkeleton',
  props: {
    itemListNumber: {
      type: Number,
      default: 3,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.list-skeleton {
  &::v-deep .v-skeleton-loader {
    height: 48px;

    &__text {
      $margin-y: 12px;

      border-radius: $border-radius-md;
      height: calc(100% - $margin-y);
      margin-top: $margin-y / 2;
      margin-bottom: $margin-y / 2;
    }
  }
}
</style>
